/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * ユーザードメインのエラーコード
 */
export type UserDomainErrorCode = (typeof UserDomainErrorCode)[keyof typeof UserDomainErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserDomainErrorCode = {
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  NO_PERMISSION: 'NO_PERMISSION',
  INVALID_ROLE: 'INVALID_ROLE',
  NO_PROFILE: 'NO_PROFILE',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  CANNOT_DEACTIVATE_SELF: 'CANNOT_DEACTIVATE_SELF',
  CANNOT_CHANGE_OWN_ROLE: 'CANNOT_CHANGE_OWN_ROLE',
  DIVISION_NOT_FOUND: 'DIVISION_NOT_FOUND',
} as const;
